var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"host-sidebar"},[_c('header',{staticClass:"menu-header d-flex align-items-center justify-content-center bg-td-grey-darker"},[(!_vm.$slots.header)?[_c('div',{staticClass:"td-logo"},[_c('LogoComponent',{staticClass:"bg-white"})],1)]:_vm._t("header")],2),_c('div',{staticClass:"contents"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }